import { QueueItem, SpeechEventCallback } from './types';

/**
 * 音声合成キューを管理するクラス
 */
export class QueueManager {
  private queue: QueueItem[] = [];
  private isProcessing: boolean = false;
  private onEvent?: SpeechEventCallback;

  constructor(onEvent?: SpeechEventCallback) {
    this.onEvent = onEvent;
  }

  /**
   * テキストをキューに追加
   */
  enqueueText(text: string): void {
    const item: QueueItem = {
      type: 'text',
      content: text,
    };

    this.queue.push(item);
    this.notifyQueueUpdate();

    console.log('🔊 テキストをキューに追加:', text.substring(0, 50) + '...');
  }

  /**
   * 分割されたセグメントをキューに追加
   */
  enqueueSplitSegments(segments: string[]): void {
    const item: QueueItem = {
      type: 'split_segments',
      content: `split_segments_${Date.now()}`, // ユニークなID
      segments,
    };

    this.queue.push(item);
    this.notifyQueueUpdate();

    console.log('🗓️ 分割TTSをキューに追加:', segments.length + '個のセグメント');
  }

  /**
   * 次のキューアイテムを取得
   */
  dequeue(): QueueItem | null {
    const item = this.queue.shift();
    if (item) {
      this.notifyQueueUpdate();
    }
    return item || null;
  }

  /**
   * キューの先頭にアイテムを戻す
   */
  unshift(item: QueueItem): void {
    this.queue.unshift(item);
    this.notifyQueueUpdate();
  }

  /**
   * キューをクリア
   */
  clear(): void {
    this.queue = [];
    this.notifyQueueUpdate();
    console.log('🗑️ 音声キューをクリア');
  }

  /**
   * 処理状態を設定
   */
  setProcessing(isProcessing: boolean): void {
    this.isProcessing = isProcessing;
  }

  /**
   * キューの状態を取得
   */
  get length(): number {
    return this.queue.length;
  }

  /**
   * 処理中かどうか
   */
  get processing(): boolean {
    return this.isProcessing;
  }

  /**
   * キューが空かどうか
   */
  get isEmpty(): boolean {
    return this.queue.length === 0;
  }

  /**
   * キュー更新を通知
   */
  private notifyQueueUpdate(): void {
    this.onEvent?.({ type: 'queue_updated', queueLength: this.queue.length });
  }
}
